import { IonButton, IonContent, IonIcon, IonPage } from '@ionic/react';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import React from 'react';

import { arrowBackOutline, camera } from 'ionicons/icons';

import Alert from '../../components/UI/Alert';
import CameraActionSheet from '../../components/UI/CameraActionSheet';
import Modal from '../../components/UI/Modal';
import OptionCard from '../../components/UI/OptionCard';
import Spinner from '../../components/UI/Spinner';
import { usePetPage } from '../../hooks/Helpers/usePetPage';
import './PetPage.scss';

const PetPage: React.FC = () => {
  const {
    pet,
    isDawer,
    isCoverageExpired,
    isUpdatingProfilePic,
    handleImageLoad,
    petOptions,
    modal,
    alert,
    camera: cameraSheet,
    goBack,
    openEditForm,
  } = usePetPage();

  return (
    <IonPage className={`pet-page${isDawer ? ' pet-page--dawer' : ''}`}>
      <IonContent>
        <div className="pet-page__img-container">
          <img src={pet.image} alt={pet.nombre} onLoad={handleImageLoad} />

          {isUpdatingProfilePic && (
            <div className="pet-page__img-overlay">
              <Spinner />
            </div>
          )}

          <IonButton
            className="pet-page__btn pet-page__btn--left"
            fill="clear"
            onClick={goBack}
          >
            <IonIcon icon={arrowBackOutline} />
          </IonButton>

          <IonButton
            className="pet-page__btn pet-page__btn--right"
            fill="clear"
            onClick={cameraSheet.open}
          >
            <IonIcon icon={camera} />
          </IonButton>
        </div>

        <div className="pet-page__content">
          <div className="pet-page__content-head">
            <div>
              <div className="pet-page__content-head--name">{pet.nombre}</div>
              <div className="pet-page__content-head--data">{pet.raza}</div>
            </div>

            <span className="pet-page__edit-icon" onClick={openEditForm}>
              <PencilSimpleIcon size={22} weight="fill" />
            </span>
          </div>

          {isCoverageExpired && (
            <div className="pet-page__coverage-lock">
              <strong>Cobertura finalizada</strong>
              <span>Elegí un plan para volver a habilitar las funciones.</span>
            </div>
          )}

          <div className="pet-page__content-options">
            {petOptions.map(({ onClick, icon, title, description, disabled }, index) => (
              <OptionCard
                key={index}
                onClick={onClick}
                icon={icon}
                title={title}
                description={description}
                disabled={disabled}
              />
            ))}
          </div>
        </div>

        <CameraActionSheet
          showCameraOptions={cameraSheet.isOpen}
          setShowCameraOptions={cameraSheet.close}
          takePhoto={cameraSheet.takePhoto}
          selectFromGallery={cameraSheet.selectFromGallery}
        />

        <Modal isOpen={modal.isOpen} onClose={modal.closeModal} {...modal}>
          {modal.content}
        </Modal>

        <Alert
          isOpen={alert.isOpen}
          header={alert.header}
          message={alert.message}
          buttons={alert.buttons}
          onDidDismiss={alert.hideAlert}
        />
      </IonContent>
    </IonPage>
  );
};

export default PetPage;
